import type { DummyFoods } from './dummyFoods'

export const rice: DummyFoods = {
  Rice: {
    Brown: {
      Cooked: ['Brown rice (cooked)'],
      Dry: ['Brown rice (dry)'],
    },
    White: {
      Cooked: ['White rice (cooked)'],
      Dry: ['White rice (dry)'],
    },
    Wild: {
      Cooked: ['Wild rice (cooked)'],
      Dry: ['Wild rice (dry)'],
    },
  },
}
